import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Button, Table, Space, message } from "antd";
import { confirmModal } from "../../../../../reusable/ModalWizz";
import BankruptcyModel from "./BankruptcyModel";
import {
  getBankruptcy,
  deleteBankruptcy,
} from "../../../../../services/adminForm.services";
import { useQuery } from "../../../../../helpers/utility";

const Bankruptcy = ({ disable }) => {
  const query = useQuery();
  const applicationId = query.get("id");
  const [visible, setVisible] = useState(false);
  const [editTable, setEditTable] = useState(null);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableData, setTableData] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const refreshPage = () => {
    setRefresh((prevValue) => !prevValue);
  };

  useEffect(() => {
    setTableLoading(true);
    getBankruptcy(applicationId)
      .then((res) => {
        setTableData(res.data);
        setTableLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setTableLoading(false);
      });
  }, [refresh]);
  const columns = [
    {
      title: "Index No",
      dataIndex: "index_no",
      key: "index_no",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Court",
      dataIndex: "court",
      key: "court",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Plaintiff",
      dataIndex: "plaintiff",
      key: "plaintiff",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Defendant",
      dataIndex: "defendant",
      key: "defendant",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Filing Date",
      dataIndex: "filing_date",
      key: "filing_date",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Disposition Date",
      dataIndex: "disposition_date",
      key: "disposition_date",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Action",
      key: "action",
      width: 160,
      render: (record) => (
        <Space size="middle">
          <span
            className="footer-links"
            onClick={() => openModal({ formData: record, status: "update" })}
          >
            Edit
          </span>
          <span
            className="footer-links"
            onClick={() => {
              confirmModal({
                title: `Are you sure to delete this record?`,
                onOk: () => removeColumn(record.id),
              });
            }}
          >
            Delete
          </span>
        </Space>
      ),
    },
  ];

  const openModal = (data) => {
    setVisible(true);

    setEditTable(data);
  };

  const removeColumn = (id) => {
    deleteBankruptcy(id)
      .then((res) => {
        message.success("Deleted");
        refreshPage();
      })
      .catch((err) => {
        message.error("Failed to remove Bankruptcy");
        console.log(err);
      });
  };

  function saveBankruptcy(data) {}

  return (
    <Fragment>
      <Row style={disable ? { pointerEvents: "none" } : {}}>
        <Col>
          <Button
            onClick={() => openModal({ status: "create" })}
            type="secondary"
            style={{
              marginBottom: 16,
            }}
          >
            Add Details
          </Button>
        </Col>
        <Col span={24}>
          <Table
            size="small"
            columns={columns}
            pagination={false}
            dataSource={tableData}
            loading={tableLoading}
            scroll={{ x: 800 }}
          />
        </Col>
      </Row>
      {visible && (
        <BankruptcyModel
          create={saveBankruptcy}
          setVisible={setVisible}
          title="Bankruptcy"
          editTable={editTable}
          refresh={refreshPage}
        />
      )}
    </Fragment>
  );
};

export default Bankruptcy;
